import type { FormHTMLAttributes } from 'react';

export function FormRow({
  framed = false,
  className,
  ...props
}: FormHTMLAttributes<HTMLFormElement> & {
  framed?: boolean;
}) {
  const classes = [framed ? 'panel' : '', 'toolbar-form', className].filter(Boolean).join(' ');
  return <form {...props} className={classes} />;
}
